import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {

  @Input() percent: number;
  @Input() height: number = 9;

  constructor() { }

  ngOnInit() {}

}
